import React from "react";
import { connect } from "react-redux";
import { setVideoLayoutProperty } from "../actions";
import styled from "styled-components";
import { PAGING_TYPE } from "../constants";

const ArrowStyled = styled.div`
    display: ${ props => props.isNone ? "none" : "bloack"};
    min-width: ${(props) => (props.isVertical ? "100%" : (props.isNone ? "0px" : "30px"))}; 
    min-height: ${(props) => (props.isVertical ? (props.isNone ? "0px" : "30px") : "100%")}; 
    float: left; position: relative;
    cursor: pointer; background: #123;

    margin: ${(props) => (props.type === PAGING_TYPE.PREV ? "0 auto 0 0!important;" : "0 0 0 auto!important")}; 

    .previous {
        display: ${(props) => (props.isVertical ? "none" : "block")}; 
        width: 15px; height: 17px;
        background-position: -297px -321px;

        &:hover {
            background-position: -321px -321px;
        }
    }
    .number {
        margin-top: ${(props) => (props.isVertical ? 0 : "27px")}; 
        width: 100%; text-align: center;
    }

    .next {
        display: ${(props) => (props.isVertical ? "none" : "block")}; 
        width: 15px; height: 17px;
        background-position: -344px -321px;
        &:hover {
            background-position: -367px -321px;
        }
    }
`;

function LayoutPaging({ 
    dispatch, type, isVertical = false, isShowArrow, showArrow, page, maxPage
}) {
    const _onClick = () => {
        let changePage = page;
        if ( type === PAGING_TYPE.PREV ) {
            if (page - 1 > 0) changePage = page -1;
        } else {
            if (page + 1 <= maxPage) changePage = page + 1;
        }

        if (changePage !== page) dispatch(setVideoLayoutProperty({ 
            page: changePage,
            isShowArrow: {
                ...isShowArrow,
                next: changePage < maxPage ? true : false,
                prev: changePage > 1 ? true : false,
                maxPage
            }            
        }));
    }
    
    return (
        <>  
            { showArrow ? 
                <ArrowStyled className="arrow" type={type} isVertical={isVertical} onClick={_onClick}>
                    <span className={`icoImg ${type} center`}></span>
                    <p className="center number">{page} / {maxPage} </p>
                </ArrowStyled>
                : <ArrowStyled className="arrow" type={type} isVertical={isVertical} isNone={true}></ArrowStyled>
            }
        </>
    );
}

function _mapStateToProps(state, ownProps) {
    const { isShowArrow, page } = state['features/video-layout-mode'];
    const { next, prev, maxPage } = isShowArrow;

    return {
        page, maxPage,
        isShowArrow,
        showArrow: ownProps.type === PAGING_TYPE.PREV ? prev : next
    }
}

export default connect(_mapStateToProps)(LayoutPaging);